// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import DiscountBandsTable from './DiscountBandsTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFaresSubSystem } from 'selectors';
import AddDiscountBand from './addDiscountBand';
import EditDiscountBand from './updateDiscountBand';
import ViewDiscountBand from './view-DiscountBand';

const DiscountBands: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const { pathname } = useLocation();
  const isPromotionsRoute = pathname.includes('/fare-products/promotions');

  const subsystemName = isPromotionsRoute ? 'Promotions' : 'FareProducts';

  const hasDiscountBandsAddAccess = useTypedSelector(state =>
    hasWriteAccessToFaresSubSystem(state, subsystemName)
  );

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasDiscountBandsAddAccess ? <AddDiscountBand/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasDiscountBandsAddAccess ? <EditDiscountBand/> : <NotAuthorized />}
        </Route>
        
        <Route path={`${baseURL}/:id`}>
          <ViewDiscountBand/>
        </Route>
        
        <Route exact path={`${baseURL}`}>
          <DiscountBandsTable key={pathname} />
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { DiscountBands };
